import { faThumbsUp } from '@fortawesome/pro-solid-svg-icons';
import { ActionButton, HeadingItem, OrderCard } from 'components';
import { AppointmentCard } from 'components/load-appointments';
import { Popup } from 'devextreme-react/popup';
import { ScrollView } from 'devextreme-react/scroll-view';
import React, { FC, Fragment } from 'react';
import { ChangeOperation, ChangeType } from 'services/enums';
import { Order, Stop, TripChange } from 'services/types';
import './trip-update-popup.scss';

type Props = {
    isVisible: boolean,
    changes: TripChange[],
    onClickOk: () => void
}

export const TripUpdatePopup: FC<Props> = ({ isVisible, changes, onClickOk }) => {

    const stopsAdded: TripChange[] = changes.filter(change => change.type === ChangeType.Stop && change.operation == ChangeOperation.Insert)
    const stopsRemoved: TripChange[] = changes.filter(change => change.type === ChangeType.Stop && change.operation == ChangeOperation.Delete)
    const ordersAdded: TripChange[] = changes.filter(change => change.type === ChangeType.Order && change.operation == ChangeOperation.Insert)

    return (
        <Popup
            visible={isVisible}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showTitle={false}
            width={325}
            height={575}
        >
            <HeadingItem text={'Load Changes'} />
            <ScrollView>
                <div className={'trip-update-popup-container'}>
                    <div className={'trip-update-popup-title'}>{changes.length > 0 ? `Changes have been made to your load` : `No changes to display. Press OK to continue`}</div>
                    { stopsAdded.length > 0 &&
                        <Fragment>
                            <div className={'trip-update-popup-subtitle'}>Stops have been added to your load</div>
                            {stopsAdded.map(change => <AppointmentCard key={change.value.id} stop={change.value as Stop} isReadOnly={true}/>)}
                        </Fragment>
                    }
                    { stopsRemoved.length > 0 &&
                        <Fragment>
                            <div className={'trip-update-popup-subtitle'}>Stops have been removed from your load</div>
                            {stopsRemoved.map(change => <AppointmentCard key={change.value.id} stop={change.value as Stop} isReadOnly={true}/>)}
                        </Fragment>
                    }
                    { ordersAdded.length > 0 &&
                        <Fragment>
                            <div className={'trip-update-popup-subtitle'}>Orders have been added to your load</div>
                            {ordersAdded.map(change => <OrderCard key={change.value.id} order={change.value as Order} />)}
                        </Fragment>
                    }
                    <div className={'trip-update-popup-button-row'}>
                        <ActionButton
                            icon={faThumbsUp}
                            buttonColor={'#82BC24'}
                            onClick={onClickOk}
                            buttonText={'OK'}
                        />
                    </div>
                </div>
            </ScrollView>
        </Popup>
    )
}
